import axios from 'axios'
const deleteRequest = async (route, data, headerData) => {
  const del = await axios.delete(`${process.env.REACT_APP_API_URL + route}`,
  {headers:headerData}
  )
  return del;
}

export default deleteRequest;
